import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { dynamicLinksQueries } from '../queries/dynamic-links.queries'
import { dynamicLinkService } from '../services/dynamic-link.service'
import type { ListDynamicLinksInput } from '../types/list-dynamic-links-input.type'
import type { UpdateDynamicLinkInput } from '../types/update-dynamic-survey-input.type'

/**
 * Hook to fetch the list of dynamic links
 */
export function useListDynamicLinks(input: ListDynamicLinksInput) {
  return useQuery({
    ...dynamicLinksQueries.list(input),
    enabled: Boolean(input?.createdDateFrom && input?.createdDateTo),
  })
}

/**
 * Hook to update an existing dynamic link
 */
export function useUpdateDynamicLink() {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (input: UpdateDynamicLinkInput) =>
      await dynamicLinkService.updateDynamicLink(input),
    onSuccess: () => {
      // Invalidate all dynamic links queries to refetch updated data
      void queryClient.invalidateQueries({
        queryKey: dynamicLinksQueries._def,
      })
      enqueueSnackbar(t('views.dynamicLinks.editedSuccefullyAlert'), {
        variant: 'success',
      })
    },
  })
}
